import React, { useEffect, useState } from "react"
import { get } from "lodash"
import { loadTexts } from "../../utils/i18n"

import "./index.less"
import { Table, Tag,Popover,Tooltip } from "antd"
import Bubbles from "../Bubbles"
import imgMark from "images/mark_item.svg"
const ResultByDimensionActionPlan = (props) => {
  const intl = loadTexts("dashboard")
  const [finalData, setFinalData] = React.useState([])
  const [selectedRowKeys, setSelectedRowKeys] = React.useState(
    props.viewModalAction === true ? props.selectedDimension : []
  );

  const [selectedRows, setSelectedRows] = React.useState([])

  useEffect(() => {
    const { data } = props
    const helperData = data.filter((item) => !item.engagement)
    const testData = helperData.map((item) => {
      if (typeof item.childs !== "undefined") {
        item.childs = item.childs.filter((child) => !child.id_question)
        if (item.childs.length === 0) {
          delete item.childs
        }
        if (item.childs) {
          item.childs = item.childs.map((child) => {
            if (child.childs) {
              child.childs = child.childs.filter(
                (grandChild) => !grandChild.id_question
              )
              if (child.childs.length === 0) {
                delete child.childs
              }
            }
            return child
          })
        }
      }

      return item
    })

    setSelectedRowKeys( props.viewModalAction === true ? props.selectedDimension : [])
    setSelectedRows(props.viewModalAction === true ? selectedRows : [] )
    setFinalData(testData)
  }, [props.data])
  const renderBubble = (text, record) => {
    return (
      <div
        className="bubble"
        style={
          parseFloat(record.impact) == 0
            ? { gridTemplateColumns: "auto auto auto" }
            : {}
        }>

          <div />

        <span
          style={
            parseFloat(record.impact) == 0
              ? { marginLeft: 0, textAlign: "center", color: "#8d8a8d" }
              : {}
          }>
          {parseFloat(record.impact) == 0 ? (
            <Tooltip title={intl.resultByDimensionActionPlan.notSignificativeImpact}>
              <span style={{ color: "#8D8A8D" }}>-</span>
            </Tooltip>
          ) : (
            record.impact
          )}
        </span>
        {parseFloat(record.impact) != 0 ? (
          <Bubbles
            left={parseFloat(record.impact)}
            right={parseFloat(record.impact)}
          />
        ) : (
          <div />
        )}
      </div>
    )
  }
  const columns = () => {
    let baseColumns = []
    const { selectedMeditionObject } = props
    baseColumns = []

    baseColumns = [
      ...baseColumns,
      {
        title: intl.resultByDimensionActionPlan.dimensionsRow,
        dataIndex: "dimensions",
        render: (text, record) => record.dimension_name || record.question_name,
        width: "207px",
        ellipsis: true,
      },
      {
        title: intl.resultByDimensionActionPlan.resultRow,
        dataIndex: "metric_total_label",
        render: (text, record) =>
          record.anonymity_check ? (
            record.anonymity_check.valid ? (
              <Tag color={record.color}>{record.value_visible}</Tag>
            ) : (
              "-"
            )
          ) : (
            "-"
          ),
        width: "112px",
        sorter: (a, b) => a.value - b.value,
      },
      {
        title: "1 - 2",
        dataIndex: "value_1_2",
        render: (text, record) =>
          record.anonymity_check ? (
            record.anonymity_check.valid ? (
              <span className="value_text">{record.value_low_visible}</span>
            ) : (
              "-"
            )
          ) : (
            "-"
          ),
        width: "80px",
      },
      {
        title: "3",
        dataIndex: "value_3",
        render: (text, record) =>
          record.anonymity_check ? (
            record.anonymity_check.valid ? (
              <span className="value_text">{record.value_middle_visible}</span>
            ) : (
              "-"
            )
          ) : (
            "-"
          ),
        width: "80px",
      },
      {
        title: "4 - 5",
        dataIndex: "value_4_5",
        render: (text, record) =>
          record.anonymity_check ? (
            record.anonymity_check.valid ? (
              <span className="value_text">{record.value_visible}</span>
            ) : (
              "-"
            )
          ) : (
            "-"
          ),
        width: "80px",
      },
    ]
    if(selectedMeditionObject.is_engagement==1 && selectedMeditionObject.id_scope_type==1){
      baseColumns = [
        ...baseColumns,
        {
          title:  intl.resultByDimensionActionPlan.impact,
          dataIndex: "bubbles",
          render: renderBubble,
          width: "120px",
        },
      ]
    }
    return baseColumns
  }

  const rowSelection = {
    
    selectedRowKeys,
    selectedRows,
    onChange: (selectedRowKeys, selectedRows) => {
      
      setSelectedRowKeys(selectedRowKeys)
      setSelectedRows(selectedRows)
      if(!props.viewModalAction){
        props.setStateFrom("selectedDimension", selectedRowKeys)
      }
      props.setStateFrom("selectRowsDimensions", selectedRowKeys)
      props.setStateFrom("disabledSubmit", selectedRowKeys.length==0)

      props.setStateFrom("selectedRows", selectedRows)

 
      props.setStateFrom("dimension_name", selectedRows[0].name)
      props.setStateFrom("dimension_color", selectedRows[0].color)
      props.setStateFrom("value_visible", selectedRows[0].value_visible)
      props.setStateFrom("id_dimension", selectedRows[0].id_dimension)
      props.setStateFrom("id_company", selectedRows[0].id_company)
      props.setStateFrom("id_dimension_parent", selectedRows[0].id_dimension_parent)
      props.setStateFrom("disableButtonGenerate", selectedRows.length==0)


    },
    onSelect: (record, selected, selectedRows) => {
      // console.log(record, selected, selectedRows);
    },
  }

  return (
    <Table
      className="table-result-by-dimension-action-plan"
      bordered
      size="small"
      columns={columns()}
      rowKey={(record) => {
        if (record.id_question) {
          return record.id_question
        }
        return record.id_dimension
      }}
      dataSource={finalData}
      expandable={{
        childrenColumnName: "childs",
        expandIconColumnIndex: 2,
      }}
      rowSelection={{ ...rowSelection, checkStrictly: true , type: props.modalActionPlanCreateIa && !props.viewModalAction  ? 'radio': 'checkbox' }}
    />
  )
}

export default ResultByDimensionActionPlan
